export const EMAIL_REGEX = `^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;

export const TEXTFIELD_ALLOW = {
  NUMERIC: /[^0-9]/g,
  NUMERIC_ENDASH: /[0-9-]/g,
  NUMERIC_REAL: /[^1-9]/g,
  POSITIVE_DECIMAL: /[^0-9.]/g,
  ALPHABET: /[^a-zA-Z]/g,
  ALPHANUMERIC: /[^0-9a-zA-Z]/g,
  ALPHANUMERIC_DOT: /[^0-9a-zA-Z.]/g,
  FULL_WIDTH_HIRA_KANA_KANJI: /[^ぁ-ゖァ-ヺヽヾゝゞ々〆〇一-鿿゛゜、。・ー！-～｡-ﾟ!-~\s]+/,
  FULL_WIDTH_FURIGANA: /[^ぁ-んァ-ン]+/,
  HALF_WIDTH_HIRA_KANA: /[ｧ-ﾝﾞﾟ]/g,
};

export const TEXTFIELD_PREVENT = {
  [TEXTFIELD_ALLOW.NUMERIC]: [",", ".", "-", "+", "e", "E"],
  [TEXTFIELD_ALLOW.POSITIVE_DECIMAL]: [",", "-", "+", "e", "E"],
  [TEXTFIELD_ALLOW.NUMERIC_ENDASH]: [",", "-", "+", "e", "E"],
};

export const HASHTAG_REGEX = /\#[\wぁ-んァ-ン一-龥-ー]+/g;
export const HTMLTAG_REGEX = /<[\w\s\="\:\(),%;\/]+>/g;
